import React, { useState } from 'react';

import styled from 'styled-components';

import { createGroup } from 'apis/GroupAPI';
import { useRootContext } from 'components/layout/RootContext';
import Button from 'components/lib/Button';
import { GroupType } from 'types/groups';

import GroupsCreateEditModal from './GroupsCreateEditModal';
import { useGroupsContext } from '../GroupsContext';

const PlusButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const GroupsCreateButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { showMessage } = useRootContext();

  const { refetch } = useGroupsContext();

  const onCreate = async (group: GroupType) => {
    await createGroup(group)
      .then((result) => {
        showMessage('success', 'Group created successfully');
        setOpen(false);
        refetch();
      })
      .catch((err) => {
        showMessage('error', 'Trouble creating group');
      });
  };

  return (
    <div>
      <PlusButton type={'primary'} onClick={() => setOpen(true)}>
        <img src="/icons/add.svg" height="24px" width="24px" alt="add" />
        <span>Add Group</span>
      </PlusButton>
      {open && (
        <GroupsCreateEditModal open={open} handleClose={() => setOpen(false)} onSubmit={onCreate} title="Add Group" />
      )}
    </div>
  );
};

export default GroupsCreateButton;
